const PASSWORD_SPECIAL_CHARS = /[!@#$%^&*.]/;

/**
 * Returns all password rule violations for display under the field.
 */
export const getPasswordValidationErrors = (password, t) => {
  if (!password) return [];

  const errors = [];
  if (password.length < 8) {
    errors.push(t("errorHelperText.passwordMinLength"));
  }
  if (!/[A-Z]/.test(password)) {
    errors.push(t("errorHelperText.passwordUppercase"));
  }
  if (!/[0-9]/.test(password)) {
    errors.push(t("errorHelperText.passwordNumber"));
  }
  if (!PASSWORD_SPECIAL_CHARS.test(password)) {
    errors.push(t("errorHelperText.passwordSpecial"));
  }
  return errors;
};

export const isPasswordFormatValid = (password) => {
  if (!password || password.length < 8) return false;
  if (!/[A-Z]/.test(password)) return false;
  if (!/[0-9]/.test(password)) return false;
  if (!PASSWORD_SPECIAL_CHARS.test(password)) return false;
  return true;
};
